import {ConnectionPool} from "mssql";
import {Config, Environment} from "./config";
import {buildFlynotesServer, FlynotesServer} from "./FlynotesServer";
import {R4ServerData} from "./ServerDataTypes";
import {buildLogging, Logging} from "./Logging";
import {Npm} from "./npm";
import {buildSqs, Sqs} from "./Sqs";

export class ApplicationScope {
  public readonly config: Config;
  public readonly connectionPool: ConnectionPool;
  public readonly mssql: any;
  public readonly flynotesServer: FlynotesServer;
  public readonly licenceKeyData: R4ServerData;
  public readonly logging: Logging;
  public readonly npm: Npm;
  public readonly licenceKey: string;
  public readonly sqs: Sqs;

  public static async build(config: Config, licenceKey: string): Promise<ApplicationScope> {
    const logging = buildLogging(config.environment, config.logging);

    /*
    Commented out so that we don't have logging every hour from every install. Can re-enable to debug.
     */
    // logging.log({
    //   message: "Initialising application scope",
    //   licenseKey: licenceKey,
    //   config
    // });

    try {
      const flynotesServer = buildFlynotesServer(config.flynotesServer, logging);
      const licenceKeyData = await flynotesServer.getLicenceKeyData(licenceKey);
      const npm = new Npm(config.npmCommand, config.packageJsonPath);

      let mssql;

      try {
        mssql = require(config.sqlLibraryName);
      } catch (e) {
        // If driver is missing, this means we're running on windows and should install it
        if (config.sqlLibraryName === 'mssql/msnodesqlv8') {

          logging.log({
            message: "msnodesqlv8 not installed. Installing now.",
          });
          await npm.updateLibrary('msnodesqlv8', '0.7.2');

          process.exit(0);
        }
      }

      let connectionPool;

      for(const connectionParam of config.connectionParams){
        try {
          connectionPool = await (new mssql.ConnectionPool({
            ...connectionParam
          }) as ConnectionPool).connect();

          break;
        } catch (e){
          // Try the next connection params in case of error
          console.log(connectionParam);
          throw Error(e);
        }
      }

      console.log(connectionPool);

      if(!connectionPool)
        throw Error('Could not initialise SQL Server connection from any available config');


      const sqs = buildSqs(config.sqs, licenceKeyData);

      return {
        npm,
        config,
        connectionPool,
        mssql,
        flynotesServer,
        licenceKeyData,
        logging,
        licenceKey,
        sqs
      }
    } catch (e) {
      logging.log({
          message: `Error initialising application scope: ${e.message}`,
          stack: e.stack
        },
        'error');

      throw e;
    }
  }
}
